import Enum from "../../../enums/Enum";

const DirectBillingItemStatusEnum = new Enum({
    CREATED: {name: "Created"},
    SENT: {name: "Sent"},
    RESPONDED: {name: "Responded"},
    CANCELLED: {name: "Cancelled"}
});

export default DirectBillingItemStatusEnum;